import React from 'react';
import { Link } from 'react-router-dom';

const CTASection: React.FC = () => {
  return (
    <section 
      className="py-20 bg-cover bg-center bg-no-repeat relative"
      style={{
        backgroundImage: `linear-gradient(rgba(20, 184, 166, 0.9), rgba(20, 184, 166, 0.9)), url('https://public.readdy.ai/ai/img_res/516c6936411b3090d470b43d6cfcbc3c.jpg')`
      }}
    >
      <div className="container mx-auto px-6 text-center text-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Ready to Start Your Business Acquisition Journey?
          </h2>
          
          <p className="text-xl mb-8 text-teal-100">
            Choose from our Premium or Elite programs and take the first step towards business ownership with expert guidance every step of the way.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div className="text-center">
              <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-star-line text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Expert Guidance</h3>
              <p className="text-teal-100 text-sm">Certified business brokers with proven track record</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Comprehensive Support</h3>
              <p className="text-teal-100 text-sm">End-to-end assistance from search to acquisition</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-trophy-line text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Proven Results</h3>
              <p className="text-teal-100 text-sm">500+ successful business acquisitions</p>
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link 
              to="/consultation" 
              className="bg-white text-teal-600 hover:bg-gray-100 px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-check-line mr-2"></i>
              Schedule Free Consultation
            </Link>
            
            <Link 
              to="/contact" 
              className="border-2 border-white text-white hover:bg-white hover:text-teal-600 px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              Contact Us Today
            </Link>
          </div>
          
          <div className="mt-12 p-6 bg-white bg-opacity-10 rounded-2xl backdrop-blur-sm">
            <h3 className="text-2xl font-bold mb-4">Two Programs Designed for Your Success</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left">
              <div className="flex items-center">
                <i className="ri-check-double-line text-xl mr-3 text-teal-200"></i>
                <span>Premium: 5 Qualified Business Opportunities</span>
              </div>
              <div className="flex items-center">
                <i className="ri-check-double-line text-xl mr-3 text-teal-200"></i>
                <span>Elite: 10 Businesses + 10 Months Advisory</span>
              </div>
              <div className="flex items-center">
                <i className="ri-check-double-line text-xl mr-3 text-teal-200"></i>
                <span>SBA Loan Pre-Approval Support</span>
              </div>
              <div className="flex items-center">
                <i className="ri-check-double-line text-xl mr-3 text-teal-200"></i>
                <span>Certified Business Broker Consultation</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
